import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { acceptCookieConsent, isCookieConsentAccepted } from '../utils/cookieConsent';

const COOKIE_POLICY_PATH = '/cerez-politikasi';

const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(() => !isCookieConsentAccepted());

  const handleAccept = useCallback(() => {
    acceptCookieConsent();
    setVisible(false);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="sb-cookie-consent"
      role="dialog"
      aria-labelledby="sb-cookie-consent-title"
      aria-describedby="sb-cookie-consent-desc"
      aria-live="polite"
    >
      <div className="sb-cookie-consent__card shadow">
        <h2 id="sb-cookie-consent-title" className="sb-cookie-consent__title h6 mb-2">
          Çerez Kullanımı
        </h2>
        <p id="sb-cookie-consent-desc" className="sb-cookie-consent__text small mb-3">
          SadeceBilgisayar, oturum yönetimi, tercihlerinizi hatırlama ve site performansını
          ölçme amacıyla çerezler ile benzeri teknolojiler kullanır. Devam ederek bunları kabul
          etmiş sayılırsınız.
        </p>
        <div className="sb-cookie-consent__actions d-flex flex-wrap gap-2">
          <Button type="button" className="btn btn-primary btn-sm" onClick={handleAccept}>
            Kabul Et
          </Button>
          <Link
            to={COOKIE_POLICY_PATH}
            className="btn btn-outline-secondary btn-sm"
          >
            Detayları Gör
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
